import React, { useState } from 'react';
import { useStore } from '../../context/StoreContext';

export default function LoginModal() {
  const { loginModalOpen, setLoginModalOpen, requestOtp, verifyOtp, otpSent, pendingCheckout, isLoggedIn } = useStore();
  const [email, setEmail] = useState('');
  const [otpInput, setOtpInput] = useState('');
  const [step, setStep] = useState('email'); // 'email' or 'otp'

  const handleRequestOtp = async (e) => {
    e.preventDefault();
    if (!email.includes('@')) {
      alert('Please enter a valid email');
      return;
    }
    await requestOtp(email);
    setStep('otp');
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    const success = verifyOtp(otpInput);
    if (success) {
      setLoginModalOpen(false);
      setStep('email');
      setEmail('');
      setOtpInput('');
      // If there was a pending checkout, execute it
      if (pendingCheckout && typeof pendingCheckout === 'function') {
        pendingCheckout();
      }
    }
  };

  const closeModal = () => {
    setLoginModalOpen(false);
    setStep('email');
    setEmail('');
    setOtpInput('');
  };

  if (!loginModalOpen) return null;

  return (
    <div className="fixed inset-0 z-[150]">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={closeModal}></div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white rounded-2xl shadow-2xl p-6">
        <button onClick={closeModal} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600">
          <i className="ri-close-line text-xl"></i>
        </button>
        
        <div className="text-center mb-6">
          <div className="w-12 h-12 mx-auto bg-indigo-100 rounded-full flex items-center justify-center">
            <i className="ri-mail-line text-2xl text-indigo-600"></i>
          </div>
          <h3 className="font-display text-2xl mt-3">Login</h3>
          <p className="text-slate-500 text-sm mt-1">
            {step === 'email' ? 'Enter your email to receive OTP' : `We sent a code to ${email}`}
          </p>
        </div>

        {step === 'email' ? (
          <form onSubmit={handleRequestOtp}>
            <input
              type="email"
              placeholder="your@email.com"
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-indigo-500 outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="w-full mt-4 h-12 bg-indigo-600 text-white rounded-xl font-semibold hover:bg-indigo-700">
              Send OTP
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerifyOtp}>
            <input
              type="text"
              placeholder="6-digit code"
              maxLength={6}
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-indigo-500 outline-none text-center text-2xl tracking-widest"
              value={otpInput}
              onChange={(e) => setOtpInput(e.target.value.replace(/\D/g, ''))}
              required
            />
            <button type="submit" className="w-full mt-4 h-12 bg-indigo-600 text-white rounded-xl font-semibold hover:bg-indigo-700">
              Verify & Login
            </button>
            <button
              type="button"
              onClick={() => { setStep('email'); setOtpInput(''); }}
              className="w-full mt-2 text-sm text-indigo-600 underline"
            >
              ← Back to email
            </button>
          </form>
        )}
      </div>
    </div>
  );
}